"use strict";

/**
 * @classdesc
 * Factory zum Erstellen von Layer-Objekten der verwendeten Kartenbibliothek.
 * Wird vom {@link gc.gis.map.GCLayerTreeManager|Layermanager} verwendet, um
 * <code>GetMap</code>-Requests zu optimieren.
 *
 * Dafür, müssen {@link gc.gis.layer.GCAbstractLayer|GC-Layer} und die jeweiligen
 * Layerinstanzen der Kartenbibliothek miteinander in Beziehung zu einander
 * gesetzt werden. <strong>Dies muss in Implementierungen dieser Klasse
 * geschehen.</strong> Für die Beziehung <code>GC-Layer</code> zu (z.B.)
 * <code>ol.Layer</code> ist die Methode {@link gc.gis.layer.GCAbstractLayer#setImpl}
 * vorgesehen. Für die Beziehung von (z.B.) <code>ol.Layer</code> zu
 * <code>GC-Layer</code> verwendet der Layermanager eine eigene Baumstruktur,
 * deren {@link gc.gis.map.GCLayerTreeManagerTreeDef|Elemente} die hier zu
 * verwendene Eigenschaft <code>_ref</code> besitzen.
 *
 * @class
 * @extends gc.gis.GCWrappable
 * @memberof gc.gis.map
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @template L Layerinstanz
 * @template G Gruppenlayerinstanz
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} options.map Karteninstanz
 *
 * @see gc.gis.map.GCLayerTreeManager
 */
gc.gis.map.GCAbstractLayerFactory = function( options )
{
	gc.gis.GCWrappable.call( this );

	this._map = options.map;
}
gc.gis.map.GCAbstractLayerFactory.prototype = Object.create( gc.gis.GCWrappable.prototype );

/**
 * Gibt die Karteninstanz zurück, auf deren Kartenbibliotheksinstanz zugegriffen
 * wird, um Layer hinzuzufügen bzw. zu entfernen.
 *
 * @public
 * @method
 * @return {gc.gis.map.GCMapView}
 */
gc.gis.map.GCAbstractLayerFactory.prototype.getMapView = function()
{
	return this._map;
};

/**
 * Erstellt eine Gruppenlayerinstanz der Kartenbibliothek.
 *
 * @public
 * @method
 * @param {gc.gis.map.GCLayerTreeManager.GroupNode} groups
 * @return {G}
 */
gc.gis.map.GCAbstractLayerFactory.prototype.createGroupLayer = gc.gis.abstractMethod;

/**
 * Erstellt eine Layerinstanz der Kartenbibliothek aus einem GC-Layer.
 *
 * @public
 * @method
 * @param {gc.gis.layer.GCAbstractLayer} gc_layer
 * @return {L}
 */
gc.gis.map.GCAbstractLayerFactory.prototype.createLayer = gc.gis.abstractMethod;

/**
 * Erstellt eine Layerinstanz der Kartenbibliothek aus einer Liste von
 * zusammenfassbaren (davon kann hier ausgegangen werden) GC-Layern.
 *
 * @public
 * @method
 * @param {gc.gis.layer.GCAbstractLayer[]} gc_layers
 * @return {L}
 */
gc.gis.map.GCAbstractLayerFactory.prototype.createMergedLayer = gc.gis.abstractMethod;
